import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

import { Address, AddressType } from '../../models/address';

import { PageBase } from '../page-base';
import { AddressProvider } from '../../providers/address/address';
import { AccountProvider } from '../../providers/account/account';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LoginProvider } from '../../providers/login/login';

@IonicPage()
@Component({
  selector: 'page-address',
  templateUrl: 'address.html',
})
export class AddressPage extends PageBase {

  address: Address;
  types: Array<AddressType>;

  addressForm: FormGroup;

  submitAttempt: boolean;

  contactDetailsId: string;

  delivery: boolean;
  invoice: boolean;

  newAddress: boolean;

  constructor(private navCtrl: NavController, private navParams: NavParams,
    private accountProvider: AccountProvider,
    private addressProvider: AddressProvider,
    private formBuilder: FormBuilder,
    private loginProvider: LoginProvider) {

    super();

    this.initAddressTypes();
    this.initForm();

    this.address = this.navParams.get('address');
    this.contactDetailsId = this.navParams.get('contactDetailsId');

    
    if (this.address.uuid) {
      if (this.address.type) {
        if (this.address.type.name == 'INVOICE') {
          this.invoice = true;
        } else {
          this.delivery = true;
        }
      }
    } else {
      this.delivery = true;
      this.newAddress = true;
    }
  }

  keyPressHandler(keyCode) 
  {
    if(keyCode == 13) {
      this.save();
    }
  }

  initForm() {
    // Create FormGroup
    this.addressForm = this.formBuilder.group({
      street: ['', Validators.compose([Validators.required])],
      number: ['', Validators.compose([Validators.required])],
      city: ['', Validators.compose([Validators.required])],
      zip: ['', Validators.compose([Validators.required])],
      country: ['', Validators.compose([Validators.required])]
    });
  }

  initAddressTypes() {
    var delivery = new AddressType();
    delivery.name = 'DELIVERY';
    delivery.uuid = '1ba0d921-cab0-11e7-9fdc-0025904afdf6';
    var invoice = new AddressType();
    invoice.name = 'INVOICE';
    invoice.uuid = '1ba6ee70-cab0-11e7-9fdc-0025904afdf6';
    this.types = new Array<AddressType>();
    this.types.push(delivery);
    this.types.push(invoice);
  }

  async save() {
    if (!this.addressForm.valid || !(this.delivery || this.invoice)) {
      // Form Invalid
      this.submitAttempt = true;
      return;
    }

    if (!this.address.uuid) {
      // Create Address
      if (this.invoice && this.delivery) {
        // Create Invoice and Delivery version
        this.address.type = this.types[0];
        if ( this.loginProvider.isAnonymousSession ) {
          // Add to address list
          await this.addressProvider.createAddress(this.address);
          // Create shallow copy to have two address instances
          var copy = { ...this.address };
          copy.type = this.types[1];
          // Add copy to address list
          await this.addressProvider.createAddress(copy);
          this.navCtrl.pop();
          return;
        } else {
          // Add address to current account in database
          await this.addressProvider.createAddress(this.address, (await this.accountProvider.getAccount()).contact_details.uuid);
          // Change address type
          this.address.type = this.types[1];
        }
      } else if (this.delivery) {
        // Set address type to delivery
        this.address.type = this.types[0];
      } else {
        // Set address type to invoice
        this.address.type = this.types[1];
      }
      if (this.loginProvider.isAnonymousSession) {
        // Add address to list
        await this.addressProvider.createAddress(this.address);
      } else {
        // Add address to current account in database
        await this.addressProvider.createAddress(this.address, (await this.accountProvider.getAccount()).contact_details.uuid);
      }
    } else {
      // Update Address
      if (this.loginProvider.isAnonymousSession) {
        // Update address in list
        await this.addressProvider.updateAddress(this.address);
      } else {
        // Update address in database
        await this.addressProvider.updateAddress(this.address, this.contactDetailsId);
      }
    }
    this.navCtrl.pop();
  }
}


// WEBPACK FOOTER //
// ./src/pages/address/address.ts